<!-- <ng-http-loader></ng-http-loader> -->
<!-- <ng-http-loader [backdrop]="false" [backgroundColor]="'#ff0000'" [debounceDelay]="100" [extraDuration]="300" [minDuration]="300" [opacity]=".6" [spinner]="spinkit.skWave"></ng-http-loader> -->
<ng-http-loader backgroundColor="#0000FF" spinner="sk-wave"></ng-http-loader>
<router-outlet></router-outlet>